export const formatPatientName = (
  firstName: string | null | undefined,
  middleName: string | null | undefined,
  lastName: string | null | undefined,
): string => [firstName, middleName, lastName].filter(Boolean).join(' ')
